define('widgets/olark/olarkService',[], function (ko) {
    var olarkService = function (olarkMobileDialogFactory, helpViewModel) {
        var self = this;

        self.help = helpViewModel;

        self.activateMobile = function () {
            olarkMobileDialogFactory.openDialog();
        };

        self.activateTablet = function () {
            self.help.tryOpen();
        };
    };

    return olarkService;
});


